import history from './history';
import configureStore from '../configureStore';

export const { persistor, store } = configureStore(history);
